// Build timestamp - questo file viene aggiornato automaticamente ad ogni build
export const BUILD_TIMESTAMP = 1756732009645;

// Chiave per localStorage
export const BUILD_STORAGE_KEY = "app_build_timestamp";

// Lista delle rotte pubbliche che non richiedono controllo versione
const PUBLIC_ROUTES = [
    '/login',
    '/Arshades3ds/',
    '/Arshades3d/',
    '/animation',
    '/animationTwo', 
    '/animationThree',
    '/3d-animation/',
    '/Renderer/',
    '/Arshades3dLibrary/',
    '/ArshadesDemo/'
];

// Funzione per verificare se la rotta corrente è pubblica
export const isPublicRoute = () => {
    const currentPath = window.location.pathname;
    return PUBLIC_ROUTES.some(route => currentPath.includes(route));
};

// Funzione per verificare se è necessario un logout
export const shouldForceLogout = () => {
    // Se siamo in development (localhost), salta il controllo
    if (process.env.NODE_ENV === 'development') {
        return false;
    }
    
    // Se siamo su una rotta pubblica, salta il controllo
    if (isPublicRoute()) {
        return false;
    }
    
    const storedTimestamp = localStorage.getItem(BUILD_STORAGE_KEY);
    
    // Se non c'è timestamp salvato, salva quello attuale
    if (!storedTimestamp) {
        localStorage.setItem(BUILD_STORAGE_KEY, BUILD_TIMESTAMP.toString());
        return false;
    }
    
    // Se il timestamp è cambiato, forza logout
    if (storedTimestamp !== BUILD_TIMESTAMP.toString()) {
        console.log(`Nuovo build rilevato - Timestamp: ${storedTimestamp} → ${BUILD_TIMESTAMP} - Logout forzato`);
        return true;
    }
    
    return false;
};

// Funzione per aggiornare il timestamp salvato
export const updateStoredTimestamp = () => {
    localStorage.setItem(BUILD_STORAGE_KEY, BUILD_TIMESTAMP.toString());
};
